import React, { useState, useEffect } from 'react'
import CsrRouter from 'router'
// import lm from 'locale' // locale or language map
import { userLoggedInObj, isUserSignedIn } from 'utils/browserHelper'
import { getUserProfileDetails } from 'api/flights/results'
import {
    CurrencyContext,
    UserContext,
    UserProfileContext,
    OfferDataContext,
    ProfileDataContext
} from 'context/hotels/results'
import { logConsole, groupCollapsedConsole } from 'utils/logError'

import { ApolloProvider } from '@apollo/client'
import ErrorBoundary from 'components/ErrorBoundary'
import { DOMAIN_COUNTRY_MAP } from 'constants/domainConfig'
import { DOMAIN } from 'constants/base'
import { getScript } from 'utils/browserHelper'
import { getAbTestConfig } from 'api/hotels/home'
import {loginPush, responseMapper, sendProfileData} from 'utils/clevertapProfile'
import { deviceId } from 'utils/DeviceIdUtils'

function App({ client }) {
    const currencyHook = useState([])
    const userDataHook = useState(() => userLoggedInObj())
    const userProfileHook = useState({})
    const profileHook = useState({})
    const ctEnv = process.env.CT_ENV === 'production' ? 'prod' : 'staging'
    const [offerHook, setOfferHook] = useState({})

    const offerJSON = async () => {
        await getScript(`https://www.cleartrip.com/offermgmt/offerJson/${ctEnv}/offerSlot.js?` + new Date().getTime(), () => {
            setOfferHook(Math.random()) // Hack for BBD
        })
    }

    useEffect(() => {
        async function getAbData() {
            const response = await getAbTestConfig()
        }
        if (DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN') {
            getAbData()
            offerJSON()
        }
        async function getUserProfile() {
            try {
                const getResponse = await getUserProfileDetails()
                const { data, status } = getResponse || {}
                if (status == 200) {
                    const finalPayload = responseMapper(data)
                    sendProfileData(finalPayload)
                }
            } catch (e) {
                console.log('User profile details api error', e)
            }
        }
        if (isUserSignedIn() && !loginPush) {
            getUserProfile()
        }
        // deviceId()
    }, [])
    groupCollapsedConsole('Runtime Config')
    logConsole('NODE_ENV - ', process.env.NODE_ENV)
    logConsole('CT_ENV   - ', process.env.CT_ENV)
    logConsole('LANG     - ', process.env.LOCALE_LANG)
    logConsole('TEMPLATE - ', process.env.TEMPLATE)
    logConsole('SENTRY_DSN - ', process.env.SENTRY_DSN)
    logConsole('BITBUCKET_BRANCH - ', process.env.BITBUCKET_BRANCH)
    logConsole('BITBUCKET_BUILD_NUMBER - ', process.env.BITBUCKET_BUILD_NUMBER)
    logConsole('BITBUCKET_COMMIT - ', process.env.BITBUCKET_COMMIT)
    logConsole('CONTENT_DIR - ', process.env.CONTENT_DIR)
    logConsole('CT_PUBLIC_USER_API_BASE_URL - ', process.env.CT_PUBLIC_USER_API_BASE_URL)
    groupCollapsedConsole('', true)

    return (
        <ErrorBoundary>
            <div className="App flex flex-column">
                <ApolloProvider client={client}>
                    <ProfileDataContext.Provider value={profileHook}>
                        <UserContext.Provider value={userDataHook}>
                            <UserProfileContext.Provider value={userProfileHook}>
                                <OfferDataContext.Provider value={offerHook}>
                                    <CurrencyContext.Provider value={currencyHook}>
                                        <CsrRouter />
                                    </CurrencyContext.Provider>
                                </OfferDataContext.Provider>
                            </UserProfileContext.Provider>
                        </UserContext.Provider>
                    </ProfileDataContext.Provider>
                </ApolloProvider>
            </div>
        </ErrorBoundary>
    )
}

export default App
